import { useNavigate } from 'react-router-dom'
import { FiLock, FiArrowRight } from 'react-icons/fi'

const UpgradePlanPrompt = () => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="inline-flex items-center justify-center w-20 h-20 bg-purple-100 rounded-full mb-6">
        <FiLock className="h-10 w-10 text-purple-400" />
      </div>
      <h2 className="text-xl font-bold text-gray-700 mb-2">
        Funcionalidad del Plan Avanzado
      </h2>
      <p className="text-gray-500 text-center mb-6 max-w-md">
        Esta funcionalidad no esta disponible en tu plan actual.
        Actualiza al plan Avanzado para desbloquear todas las funcionalidades.
      </p>
      <button
        onClick={() => navigate('/configuracion?tab=plan')}
        className="flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-xl font-medium hover:bg-purple-700 transition-colors"
      >
        Ver planes y actualizar
        <FiArrowRight className="h-4 w-4" />
      </button>
    </div>
  )
}

export default UpgradePlanPrompt
